import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';

// Layout
import Layout from './components/Layout';

// Pages
import HomePage from './pages/HomePage';
import ProductsPage from './pages/ProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import WhyCompositesPage from './pages/WhyCompositesPage';
import SpecificationsPage from './pages/SpecificationsPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import SampleRequestPage from './pages/SampleRequestPage';
import QuoteCalculatorPage from './pages/QuoteCalculatorPage';
import ResourcesPage from './pages/ResourcesPage';
import GlossaryPage from './pages/GlossaryPage';
import FAQPage from './pages/FAQPage';
import CaseStudiesPage from './pages/CaseStudiesPage';
import ComparisonToolPage from './pages/ComparisonToolPage';

function App() {
  return (
    <Router>
      <div className="noise-overlay" aria-hidden="true" />
      <Toaster 
        position="bottom-right" 
        toastOptions={{
          style: {
            background: '#111111',
            border: '1px solid #1A1A1A',
            color: '#E8E4DC',
            fontFamily: 'JetBrains Mono, monospace',
            fontSize: '13px',
          },
        }}
      />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/products/:productId" element={<ProductDetailPage />} />
          <Route path="/why-composites" element={<WhyCompositesPage />} />
          <Route path="/specifications" element={<SpecificationsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/samples" element={<SampleRequestPage />} />
          <Route path="/quote-calculator" element={<QuoteCalculatorPage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route path="/resources/:slug" element={<ResourcesPage />} />
          <Route path="/glossary" element={<GlossaryPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/case-studies" element={<CaseStudiesPage />} />
          <Route path="/comparison-tool" element={<ComparisonToolPage />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
